module.exports = __webpack_public_path__ + "img/news7.4043e925.png";